import { Navigate } from 'react-router-dom';
import { useUserContext } from '../../context/UserContext';

/**
 * Protected route component for admin-only pages.
 *
 * Redirects non-admin users to the home page.
 * Shows loading state while checking authentication.
 */
function AdminRoute({ children }) {
  const { isLoaded, isSignedIn, isAdmin } = useUserContext();

  console.log('[AdminRoute] isLoaded:', isLoaded, 'isSignedIn:', isSignedIn, 'isAdmin:', isAdmin);

  // Wait for auth to load
  if (!isLoaded) {
    return (
      <div className="auth-loading">
        <div className="auth-loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  // Redirect if not signed in or not admin
  if (!isSignedIn || !isAdmin) {
    console.log('[AdminRoute] Redirecting - not signed in or not admin');
    return <Navigate to="/" replace />;
  }

  // Render protected content for admin users
  console.log('[AdminRoute] Rendering admin content');
  return children;
}

export default AdminRoute;
